import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface ServerStatusProps {
  status: 'online' | 'offline' | 'maintenance' | 'starting' | 'starting_soon';
  className?: string;
}

const ServerStatus: React.FC<ServerStatusProps> = ({
  status,
  className = ''
}) => {
  const { t } = useLanguage();

  const statusConfig = {
    online: {
      textKey: 'server.status.online',
      color: 'bg-green-500',
      pulse: true
    },
    offline: {
      textKey: 'server.status.offline',
      color: 'bg-red-500',
      pulse: false
    },
    maintenance: {
      textKey: 'server.status.maintenance',
      color: 'bg-yellow-500',
      pulse: false
    },
    starting: {
      textKey: 'server.status.starting_soon',
      color: 'bg-blue-500',
      pulse: true
    },
    starting_soon: {
      textKey: 'server.status.starting_soon',
      color: 'bg-purple-500',
      pulse: true
    }
  };

  const config = statusConfig[status] || statusConfig.offline;

  return (
    <div className={`flex items-center ${className}`}>
      <span className={`relative flex h-3 w-3 mr-2`}>
        <span className={`absolute inline-flex h-full w-full rounded-full ${config.color} ${config.pulse ? 'opacity-75 animate-ping' : ''}`}></span>
        <span className={`relative inline-flex rounded-full h-3 w-3 ${config.color}`}></span>
      </span>
      <span className="text-sm font-medium text-gray-800 dark:text-white">{t(config.textKey)}</span>
    </div>
  );
};

export default ServerStatus;